export const CREW_MEMBER_ABSENCE_SUCCESS_RESPONSE = 'CrewMemberAbsenceSuccessResponse';
export const CREW_MEMBER_ABSENCE_CONFLICT_WA_RESPONSE =
	'CrewMemberAbsenceConflictingWorkAssignmentsResponse';
export const CREW_MEMBER_ABSENCE_ERROR_RESPONSE = 'CrewMemberAbsenceErrorResponse';
export const CREW_MEMBER_ABSENCE_OVERLAPPING_ACTIVITIES_RESPONSE =
	'CrewMemberAbsenceOverlappingActivitiesResponse';
